<form [formGroup]="resetPasswordFormGroup" (ngSubmit)="SendResponse()">
  <div class="modal-header">
    <h5 class="modal-title pull-left">{{title}}</h5>
    <span class="errorMsgWrapper alert-danger" *ngIf="errorMessage!=null">
      <p class="text-center m-2">{{errorMessage}}</p>
    </span>
    <!-- <button type="button" class="close pull-right" aria-label="Close" (click)="Close()">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
    <div class="form-group mb-3">
      <label class="control-label title">Old Password<span class="text-danger">*</span></label>
      <input type="password" class="form-control inputBox" (change)="ValidateOldPassword()" formControlName="password"
        maxlength="250" class="form-control"
        [class.is-invalid]="isResetFormSubmitted && resetPasswordFormGroup.controls['password'].errors" />
      <div *ngIf="isResetFormSubmitted && resetPasswordFormGroup.controls['password'].errors" class="error textError">
        <div *ngIf="resetPasswordFormGroup.controls['password'].errors['required']">Please enter Old Password.</div>
      </div>
    </div>

    <div class="form-group mb-3">
      <label class="control-label title">New Password<span class="text-danger">*</span></label>
      <input type="password" class="form-control inputBox"
        [class.is-invalid]="isResetFormSubmitted && resetPasswordFormGroup.controls['newPassword'].errors"
        formControlName="newPassword" (change)="ConfirmPasswordChange()" maxlength="250" class="form-control" />

      <div *ngIf="isResetFormSubmitted && resetPasswordFormGroup.controls['newPassword'].errors"
        class="error textError">
        <div *ngIf="resetPasswordFormGroup.controls['newPassword'].errors['required']">Please enter New Password.</div>
        <div *ngIf="resetPasswordFormGroup.controls['newPassword'].errors['minlength']">New Password must be at least 6
          characters.</div>
        <div
          *ngIf="!resetPasswordFormGroup.controls['newPassword'].errors['minlength'] && resetPasswordFormGroup.controls['newPassword'].errors['pattern']">
          Password does not match with defined criteria.</div>
        <div *ngIf="resetPasswordFormGroup.controls['newPassword'].errors['oldPasswordMatched']">Old Password cannot be
          set as
          a New Password.</div>
      </div>

    </div>

    <div class="form-group mb-3">
      <label class="control-label title">Confirm Password<span class="text-danger">*</span></label>
      <input type="password" class="form-control inputBox" maxlength="250"
        [class.is-invalid]="isResetFormSubmitted && resetPasswordFormGroup.controls['confirmPassword'].errors"
        formControlName="confirmPassword" (change)="ConfirmPasswordChange()" class="form-control" />
      <div *ngIf="isResetFormSubmitted && resetPasswordFormGroup.controls['confirmPassword'].errors"
        class="error textError">
        <div *ngIf="resetPasswordFormGroup.controls['confirmPassword'].errors['required']">Please enter Confirm
          Password.
        </div>
        <div *ngIf="resetPasswordFormGroup.controls['confirmPassword'].errors['minlength']">Confirm Password must be at
          least
          6 characters.</div>
        <div *ngIf="resetPasswordFormGroup.controls['confirmPassword'].errors['notMatched']">New Password and Confirm
          Password
          do not match.</div>
      </div>

    </div>
    <p class="note"><i>New Password must contain at least one upper case letter, at least one lower case letter, at
        least one number
        and at least one of these Special Character: !, &#64;, $, #, _, not contain any spaces.</i></p>
  </div>
  <div class="modal-footer">
    <div class="d-flex justify-content-between">
      <button type="submit" class="btn btn-primary smallBtn">Save</button>
      <button class="btn btn-default smallBtn" (click)="Close()">Cancel</button>
    </div>
  </div>
</form>

<app-loader [showLoader]="showLoader"></app-loader>